export const formatUrl = (stringToFormat) => {
    let string = stringToFormat.trim();
    const chars = {'Ă':'a','ă':'a','Â':'a', 'â': 'a', 'Î': 'i', 'î': 'i', 'Ș': 's', 'ș': 's', 'Ț': 't', 'ț': 't', '&': ' si ', '@': ' ', ',': ' ', '~': ' ', '+': ' ', '=': ' '};
    string = string.toLowerCase();
    string = string.replace(/[ĂăÂâÎîȘșȚț&@,~+=]/g, m => chars[m]);
    string = string.replace(/ +/g, '-');
    string = string.replace(/[^a-z0-9\-]/g, '');
    string = string.replace(/-+/g, "-");
    string = string.replace(/^-+|-+$/g, '');

    if(!string.length || string == 'si') {
        string = 'eveniment';
    }
    return string;
}